import store from "../../../store";
import report_doc_delete from "./report_doc_delete.vue";

window.REPORT_DOC_DELETE =  new Vue({
    store,
    name : "REPORT_DOC_DELETE",
    el: '#report_doc_delete',

    data () {
        return {
            showModal: false,
        }
    },
    created () {

    },

    components : {
        report_doc_delete
    }
});
